import React from 'react';


const LibraryStats = ({ stats, spacedRepetitionStats }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Library Statistics</h3>
      
      <div className="space-y-4">
        {/* Passage vs Verse Count Stats */}
        <div>
          <h4 className="text-sm font-medium text-foreground mb-2">Overview</h4>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Total Passages</span>
              <span className="text-sm font-medium text-foreground">{stats?.totalVerses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Individual Verses</span>
              <span className="text-sm font-medium text-primary">{stats?.totalIndividualVerses || stats?.totalVerses || 0}</span>
            </div>
            {stats?.totalIndividualVerses !== stats?.totalVerses && (
              <div className="text-xs text-muted-foreground italic">
                {stats?.totalVerses} memorization units containing {stats?.totalIndividualVerses} verses
              </div>
            )}
          </div>
        </div>

        {/* Existing Status-based Stats */}
        <div className="border-t border-border pt-4">
          <h4 className="text-sm font-medium text-foreground mb-2">By Status</h4>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">New</span>
              <span className="text-sm font-medium text-primary">{stats?.newVerses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Learning</span>
              <span className="text-sm font-medium text-warning">{stats?.learningVerses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Mastered</span>
              <span className="text-sm font-medium text-success">{stats?.masteredVerses || 0}</span>
            </div>
          </div>
        </div>

        {/* New Spaced Repetition Phase Stats */}
        <div className="border-t border-border pt-4">
          <h4 className="text-sm font-medium text-foreground mb-2">By Spaced Repetition Phase</h4>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 1 (Daily)</span>
              <span className="text-sm font-medium text-destructive">{stats?.phase1Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 2 (Gradual)</span>
              <span className="text-sm font-medium text-warning">{stats?.phase2Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 3 (Weekly)</span>
              <span className="text-sm font-medium text-accent">{stats?.phase3Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 4 (W→M)</span>
              <span className="text-sm font-medium text-primary">{stats?.phase4Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 5 (Monthly)</span>
              <span className="text-sm font-medium text-primary">{stats?.phase5Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 6 (M→Q)</span>
              <span className="text-sm font-medium text-accent">{stats?.phase6Verses || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Phase 7 (Quarterly)</span>
              <span className="text-sm font-medium text-success">{stats?.phase7Verses || 0}</span>
            </div>
          </div>
        </div>

        {/* Review Schedule Stats */}
        <div className="border-t border-border pt-4">
          <h4 className="text-sm font-medium text-foreground mb-2">Review Schedule</h4>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Due Today</span>
              <span className="text-sm font-medium text-destructive">{stats?.versesDueToday || 0}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Overdue</span>
              <span className="text-sm font-medium text-warning">{stats?.versesOverdue || 0}</span>
            </div>
            {spacedRepetitionStats && (
              <>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Average Interval</span>
                  <span className="text-sm font-medium text-primary">
                    {stats?.averageInterval < 1 ? `${Math.round(stats?.averageInterval * 24)}h` :
                     stats?.averageInterval === 1 ? '1 day' :
                     stats?.averageInterval < 30 ? `${Math.round(stats?.averageInterval)} days` :
                     `${Math.round(stats?.averageInterval / 30)} month${stats?.averageInterval >= 60 ? 's' : ''}`}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Success Rate</span>
                  <span className="text-sm font-medium text-success">{Math.round(stats?.successRate || 0)}%</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Total Reviews</span>
                  <span className="text-sm font-medium text-foreground">{spacedRepetitionStats?.totalReviews || 0}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LibraryStats;